import { onlineClassesPath } from "@outschool/routes";

import { CategoryNavLink } from "./navbarCategories";

export function getCategoryUrl(category: CategoryNavLink): string {
  return category.path || onlineClassesPath(category.slug, category.basePath);
}
export function hasSubcategories(category: CategoryNavLink): boolean {
  return Boolean(
    category.getSubcategories && category.getSubcategories?.().length > 0,
  );
}
